import { Banner, BannerItem } from '@athena/forge';
import athenaConfig from '../../config';
import { getLocalizedString } from '../../utils/i18n-utils';
const { athenaNetPasswordResetUrl } = athenaConfig;

export default function InvalidUsernameOrPasswordBanner() {
  const HEADER_TEXT = getLocalizedString('errors.E0000004');
  const NON_LINK_HEADER_DESCRIPTION = getLocalizedString('invalid.username.password.description');
  const RESET_PASSWORD_LINK_TEXT = getLocalizedString('invalid.username.password.link.text');
  const DOT = '.';
  return (
    <Banner alertType='critical' className='fe_u_padding--small'>
      <BannerItem headerText={HEADER_TEXT}>
        {NON_LINK_HEADER_DESCRIPTION}
        <a href={athenaNetPasswordResetUrl}>
          {RESET_PASSWORD_LINK_TEXT}
        </a>
        {DOT}
      </BannerItem>
    </Banner>
  );
}
